module.exports = __webpack_public_path__ + "img/_ABS9786(1).783aec5e.jpg";